import { Trans } from "react-i18next";

import util from "utils/utils";

import type { NotificationContentProps } from "../../types";

export default function DiscussionReactedContent({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  context,
  status,
}: NotificationContentProps) {
  return (
    <Trans
      i18nKey="notifications.groupDiscussionReacted"
      values={{
        name: util.getEventNames(events ?? []),
        group: ownerGroup?.name || "Deleted",
      }}
    />
  );
}
